module.exports = __webpack_public_path__ + "img/DE04084.de26221c.svg";